import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';
import { ExploreService } from '../../services/explore.service';
const ticksToDate = require('ticks-to-date');

@Component({
  selector: 'morva-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class DashboardCardComponent implements OnInit, OnChanges {

  @Input() card;
  constructor(private exploreService: ExploreService) { }

  @HostListener('window:click', ['$event'])
  onClick() {
    this.card.dropped = false;
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.setDashboardDate();
    this.getDeafultImagePath();
  }

  toggleMore(event) {
    event.stopPropagation();
    this.card.dropped = !this.card.dropped;
  }

  setDashboardDate() {
    const date = ticksToDate(this.card.updateTime);
    if (date) {
      const today = new Date();
      var differenceInTime = date.getTime() - today.getTime();
      var differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
      if (differenceInDays === 0) {
        this.card.updateTime = 'امروز';
      } else if (differenceInDays === 1) {
        this.card.updateTime = 'دیروز';
      } else {
        this.card.updateTime = `${(-differenceInDays)} روز قبل`;
      }
    }
  }

  getDeafultImagePath() {
    if (!this.card.imagePath) {
      this.card.imagePath = '/assets/images/dashboard.png';
    }
  }

  starIcon(isImported) {
    const icon = isImported ? 'star' : 'star-outline';
    return icon;
  }

  onStarClick(event) {
    event.stopPropagation();
    var itemState = this.card;
    itemState.favorite = !itemState.favorite;
    this.editAsset(this.card.id, itemState);
  }

  editAsset(assetId, newAsset) {
    this.exploreService.editAsset(assetId, newAsset).subscribe();
  }

}
